
<div class="ws-delimiter">
  <div
    class="line"
    :class="lineClass"
  ></div>
  <div
    v-if="text"
    class="text ws-typo-xs"
    :class="textClass"
  >
    {{ $t(text) }}
  </div>
  <div
    v-if="text"
    class="line"
    :class="lineClass"
  ></div>
</div>
